import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

// project imports
import { getTokenLocal, getUserLocal } from 'utils/localStorage.util';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for protected routes.
 * If user is not logged in, redirect them to the login page.
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }) => {
    const token = getTokenLocal();
    const user = getUserLocal();

    if (!token || !user) {
        return <Navigate to="/" replace />;
    }

    return children;
};

AuthGuard.propTypes = {
    children: PropTypes.node
};

export default AuthGuard;
